




angular.module('forms.fields.password', [])
.directive('passwordField', function($translate){
return {
	require: ['ngModel', '^^?fieldBox'],
	restrict: 'A',
	scope: true,
	link: function($scope, element, attrs, controllers) {
		var ngModel = controllers[0];
		var fieldBox = controllers[1];

		$scope.pass = {pass:'', repeat:''};
		$scope.$watchCollection('pass', function(pass) {
			if (!pass) return;
			var value = '';

			if (!pass.repeat || (pass.pass == pass.repeat)) {
				value = pass.pass;
				if (fieldBox) {
					delete fieldBox.errors[fieldBox.field.name];
					if (pass.repeat) {
						fieldBox.setFieldState('valid', null);
					} else if (pass.pass) {
						fieldBox.setFieldState('invalid', 'Both password fields must match!');  // invisible error - wait for editing the second field, but stop form from sending
					}
				}
			} else {
				if (fieldBox) {
					fieldBox.errors[fieldBox.field.name] = 'Both password fields must match!';
					fieldBox.setFieldState('invalid', 'Both password fields must match!');
				}
			}
			ngModel.$setViewValue(value);
		}, true);
		
		ngModel.$render = function() {
			$scope.pass.pass = ngModel.$modelValue;
			$scope.pass.repeat = ngModel.$modelValue;
    	};
	},
}

});


function PasswordStrengthValidator($parse, $translate, $timeout) {
	return {
		bindToController: {
			config: '<passwordRequirements',
            value: '=value'
		},
		restrict: 'A',
        require:  'ngModel',
        controller: function($element, $scope) {
			
			var self = this;

			this.validators = {
				min_length: {
					validate: function(pass, config) {return pass.length >= config.min_length;},
					label: 'The password should be at least {{min_length}} characters long',
					is_valid: false,
					in_use: false,
				},
				one_digit: {
					validate: function(pass, config) {return (new RegExp("^(?=.*\\d)", "u")).test(pass);},
					label: 'The password must contain at least 1 digit',
					is_valid: false,
					in_use: false,
				},
				one_uppercase: {
					validate: function(pass, config) {return (new RegExp("^(?=.*\\p{Lu})", "u")).test(pass);},
					label: 'The password must contain at least 1 capital letter',
					is_valid: false,
					in_use: false,
				},
				one_lowercase: {
					validate: function(pass, config) {return (new RegExp("^(?=.*\\p{Ll})", "u")).test(pass);},
					label: 'The password must contain at least 1 lowercase letter',
					is_valid: false,
					in_use: false,
				}
			}

			this.pass_strength_validator = {}
			this.overall_valid = false;

			$scope.$watch(function(){return self.value}, function(pass){
				var overall_valid = true;
				angular.forEach(self.validators, function(validator, key) {
					if (self.config[key]) {
						validator.in_use = true;
						if (typeof pass != "string") {
							validator['is_valid'] = false;
							overall_valid = false;
						} else if (pass == "") {
							validator['is_valid'] = false;
							overall_valid = false;
						} else {
							validator['is_valid'] = validator.validate(pass, self.config);
							overall_valid &= validator['is_valid'];
						}
					} else {
						validator.in_use = false;
					}
				})
				this.overall_valid = overall_valid;
			});


        },
		controllerAs: '$passwordStrengthValidator'
	}
}

angular.module('forms.fields.password')
.directive('passwordStrengthValidator', PasswordStrengthValidator)